var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowDotPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 191,
    viewBox: "0 0 176 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3C6 4.6575 4.6575 6 3 6C1.3425 6 0 4.6575 0 3C0 1.3425 1.3425 0 3 0C4.6575 0 6 1.3425 6 3Z",
    fill: "#20E9BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 18C6 19.6575 4.6575 21 3 21C1.3425 21 0 19.6575 0 18C0 16.3425 1.3425 15 3 15C4.6575 15 6 16.3425 6 18Z",
    fill: "#20E9BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 18C22 19.6575 20.6575 21 19 21C17.3425 21 16 19.6575 16 18C16 16.3425 17.3425 15 19 15C20.6575 15 22 16.3425 22 18Z",
    fill: "#20E9BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 18C37 19.6575 35.6575 21 34 21C32.3425 21 31 19.6575 31 18C31 16.3425 32.3425 15 34 15C35.6575 15 37 16.3425 37 18Z",
    fill: "#20E9BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 18C52 19.6575 50.6575 21 49 21C47.3425 21 46 19.6575 46 18C46 16.3425 47.3425 15 49 15C50.6575 15 52 16.3425 52 18Z",
    fill: "#20E9BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 18C68 19.6575 66.6575 21 65 21C63.3425 21 62 19.6575 62 18C62 16.3425 63.3425 15 65 15C66.6575 15 68 16.3425 68 18Z",
    fill: "#20E9BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 18C83 19.6575 81.6575 21 80 21C78.3425 21 77 19.6575 77 18C77 16.3425 78.3425 15 80 15C81.6575 15 83 16.3425 83 18Z",
    fill: "#20E9BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 18C99 19.6575 97.6575 21 96 21C94.3425 21 93 19.6575 93 18C93 16.3425 94.3425 15 96 15C97.6575 15 99 16.3425 99 18Z",
    fill: "#20E9BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 18C114 19.6575 112.658 21 111 21C109.342 21 108 19.6575 108 18C108 16.3425 109.342 15 111 15C112.658 15 114 16.3425 114 18Z",
    fill: "#20E9BC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 18C130 19.6575 128.658 21 127 21C125.342 21 124 19.6575 124 18C124 16.3425 125.342 15 127 15C128.658 15 130 16.3425 130 18Z",
    fill: "#20E9BC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 18C145 19.6575 143.658 21 142 21C140.342 21 139 19.6575 139 18C139 16.3425 140.342 15 142 15C143.658 15 145 16.3425 145 18Z",
    fill: "#20E9BC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 18C160 19.6575 158.658 21 157 21C155.342 21 154 19.6575 154 18C154 16.3425 155.342 15 157 15C158.658 15 160 16.3425 160 18Z",
    fill: "#20E9BC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 18C176 19.6575 174.658 21 173 21C171.342 21 170 19.6575 170 18C170 16.3425 171.342 15 173 15C174.658 15 176 16.3425 176 18Z",
    fill: "#20E9BC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 34C6 35.6575 4.6575 37 3 37C1.3425 37 0 35.6575 0 34C0 32.3425 1.3425 31 3 31C4.6575 31 6 32.3425 6 34Z",
    fill: "#20E9BC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 34C22 35.6575 20.6575 37 19 37C17.3425 37 16 35.6575 16 34C16 32.3425 17.3425 31 19 31C20.6575 31 22 32.3425 22 34Z",
    fill: "#20E9BC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 34C37 35.6575 35.6575 37 34 37C32.3425 37 31 35.6575 31 34C31 32.3425 32.3425 31 34 31C35.6575 31 37 32.3425 37 34Z",
    fill: "#20E9BC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 34C52 35.6575 50.6575 37 49 37C47.3425 37 46 35.6575 46 34C46 32.3425 47.3425 31 49 31C50.6575 31 52 32.3425 52 34Z",
    fill: "#20E9BC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 34C68 35.6575 66.6575 37 65 37C63.3425 37 62 35.6575 62 34C62 32.3425 63.3425 31 65 31C66.6575 31 68 32.3425 68 34Z",
    fill: "#20E9BC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 34C83 35.6575 81.6575 37 80 37C78.3425 37 77 35.6575 77 34C77 32.3425 78.3425 31 80 31C81.6575 31 83 32.3425 83 34Z",
    fill: "#20E9BC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 34C99 35.6575 97.6575 37 96 37C94.3425 37 93 35.6575 93 34C93 32.3425 94.3425 31 96 31C97.6575 31 99 32.3425 99 34Z",
    fill: "#20E9BC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 34C114 35.6575 112.658 37 111 37C109.342 37 108 35.6575 108 34C108 32.3425 109.342 31 111 31C112.658 31 114 32.3425 114 34Z",
    fill: "#20E9BC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 34C130 35.6575 128.658 37 127 37C125.342 37 124 35.6575 124 34C124 32.3425 125.342 31 127 31C128.658 31 130 32.3425 130 34Z",
    fill: "#20E9BC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 34C145 35.6575 143.658 37 142 37C140.342 37 139 35.6575 139 34C139 32.3425 140.342 31 142 31C143.658 31 145 32.3425 145 34Z",
    fill: "#20E9BC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 34C160 35.6575 158.658 37 157 37C155.342 37 154 35.6575 154 34C154 32.3425 155.342 31 157 31C158.658 31 160 32.3425 160 34Z",
    fill: "#20E9BC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 34C176 35.6575 174.658 37 173 37C171.342 37 170 35.6575 170 34C170 32.3425 171.342 31 173 31C174.658 31 176 32.3425 176 34Z",
    fill: "#20E9BC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 49C6 50.6575 4.6575 52 3 52C1.3425 52 0 50.6575 0 49C0 47.3425 1.3425 46 3 46C4.6575 46 6 47.3425 6 49Z",
    fill: "#20E9BC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 49C22 50.6575 20.6575 52 19 52C17.3425 52 16 50.6575 16 49C16 47.3425 17.3425 46 19 46C20.6575 46 22 47.3425 22 49Z",
    fill: "#20E9BC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 49C37 50.6575 35.6575 52 34 52C32.3425 52 31 50.6575 31 49C31 47.3425 32.3425 46 34 46C35.6575 46 37 47.3425 37 49Z",
    fill: "#20E9BC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 49C52 50.6575 50.6575 52 49 52C47.3425 52 46 50.6575 46 49C46 47.3425 47.3425 46 49 46C50.6575 46 52 47.3425 52 49Z",
    fill: "#20E9BC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 49C68 50.6575 66.6575 52 65 52C63.3425 52 62 50.6575 62 49C62 47.3425 63.3425 46 65 46C66.6575 46 68 47.3425 68 49Z",
    fill: "#20E9BC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 49C83 50.6575 81.6575 52 80 52C78.3425 52 77 50.6575 77 49C77 47.3425 78.3425 46 80 46C81.6575 46 83 47.3425 83 49Z",
    fill: "#20E9BC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 49C99 50.6575 97.6575 52 96 52C94.3425 52 93 50.6575 93 49C93 47.3425 94.3425 46 96 46C97.6575 46 99 47.3425 99 49Z",
    fill: "#20E9BC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 49C114 50.6575 112.658 52 111 52C109.342 52 108 50.6575 108 49C108 47.3425 109.342 46 111 46C112.658 46 114 47.3425 114 49Z",
    fill: "#20E9BC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 49C130 50.6575 128.658 52 127 52C125.342 52 124 50.6575 124 49C124 47.3425 125.342 46 127 46C128.658 46 130 47.3425 130 49Z",
    fill: "#20E9BC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 49C145 50.6575 143.658 52 142 52C140.342 52 139 50.6575 139 49C139 47.3425 140.342 46 142 46C143.658 46 145 47.3425 145 49Z",
    fill: "#20E9BC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 49C160 50.6575 158.658 52 157 52C155.342 52 154 50.6575 154 49C154 47.3425 155.342 46 157 46C158.658 46 160 47.3425 160 49Z",
    fill: "#20E9BC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 49C176 50.6575 174.658 52 173 52C171.342 52 170 50.6575 170 49C170 47.3425 171.342 46 173 46C174.658 46 176 47.3425 176 49Z",
    fill: "#20E9BC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 65C6 66.6575 4.6575 68 3 68C1.3425 68 0 66.6575 0 65C0 63.3425 1.3425 62 3 62C4.6575 62 6 63.3425 6 65Z",
    fill: "#20E9BC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 65C22 66.6575 20.6575 68 19 68C17.3425 68 16 66.6575 16 65C16 63.3425 17.3425 62 19 62C20.6575 62 22 63.3425 22 65Z",
    fill: "#20E9BC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 65C37 66.6575 35.6575 68 34 68C32.3425 68 31 66.6575 31 65C31 63.3425 32.3425 62 34 62C35.6575 62 37 63.3425 37 65Z",
    fill: "#20E9BC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 65C52 66.6575 50.6575 68 49 68C47.3425 68 46 66.6575 46 65C46 63.3425 47.3425 62 49 62C50.6575 62 52 63.3425 52 65Z",
    fill: "#20E9BC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 65C68 66.6575 66.6575 68 65 68C63.3425 68 62 66.6575 62 65C62 63.3425 63.3425 62 65 62C66.6575 62 68 63.3425 68 65Z",
    fill: "#20E9BC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 65C83 66.6575 81.6575 68 80 68C78.3425 68 77 66.6575 77 65C77 63.3425 78.3425 62 80 62C81.6575 62 83 63.3425 83 65Z",
    fill: "#20E9BC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 65C99 66.6575 97.6575 68 96 68C94.3425 68 93 66.6575 93 65C93 63.3425 94.3425 62 96 62C97.6575 62 99 63.3425 99 65Z",
    fill: "#20E9BC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 65C114 66.6575 112.658 68 111 68C109.342 68 108 66.6575 108 65C108 63.3425 109.342 62 111 62C112.658 62 114 63.3425 114 65Z",
    fill: "#20E9BC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 65C130 66.6575 128.658 68 127 68C125.342 68 124 66.6575 124 65C124 63.3425 125.342 62 127 62C128.658 62 130 63.3425 130 65Z",
    fill: "#20E9BC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 65C145 66.6575 143.658 68 142 68C140.342 68 139 66.6575 139 65C139 63.3425 140.342 62 142 62C143.658 62 145 63.3425 145 65Z",
    fill: "#20E9BC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 65C160 66.6575 158.658 68 157 68C155.342 68 154 66.6575 154 65C154 63.3425 155.342 62 157 62C158.658 62 160 63.3425 160 65Z",
    fill: "#20E9BC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 65C176 66.6575 174.658 68 173 68C171.342 68 170 66.6575 170 65C170 63.3425 171.342 62 173 62C174.658 62 176 63.3425 176 65Z",
    fill: "#20E9BC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 80C6 81.6575 4.6575 83 3 83C1.3425 83 0 81.6575 0 80C0 78.3425 1.3425 77 3 77C4.6575 77 6 78.3425 6 80Z",
    fill: "#20E9BC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 80C22 81.6575 20.6575 83 19 83C17.3425 83 16 81.6575 16 80C16 78.3425 17.3425 77 19 77C20.6575 77 22 78.3425 22 80Z",
    fill: "#20E9BC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 80C37 81.6575 35.6575 83 34 83C32.3425 83 31 81.6575 31 80C31 78.3425 32.3425 77 34 77C35.6575 77 37 78.3425 37 80Z",
    fill: "#20E9BC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 80C52 81.6575 50.6575 83 49 83C47.3425 83 46 81.6575 46 80C46 78.3425 47.3425 77 49 77C50.6575 77 52 78.3425 52 80Z",
    fill: "#20E9BC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 80C68 81.6575 66.6575 83 65 83C63.3425 83 62 81.6575 62 80C62 78.3425 63.3425 77 65 77C66.6575 77 68 78.3425 68 80Z",
    fill: "#20E9BC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 80C83 81.6575 81.6575 83 80 83C78.3425 83 77 81.6575 77 80C77 78.3425 78.3425 77 80 77C81.6575 77 83 78.3425 83 80Z",
    fill: "#20E9BC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 80C99 81.6575 97.6575 83 96 83C94.3425 83 93 81.6575 93 80C93 78.3425 94.3425 77 96 77C97.6575 77 99 78.3425 99 80Z",
    fill: "#20E9BC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 80C114 81.6575 112.658 83 111 83C109.342 83 108 81.6575 108 80C108 78.3425 109.342 77 111 77C112.658 77 114 78.3425 114 80Z",
    fill: "#20E9BC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 80C130 81.6575 128.658 83 127 83C125.342 83 124 81.6575 124 80C124 78.3425 125.342 77 127 77C128.658 77 130 78.3425 130 80Z",
    fill: "#20E9BC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 80C145 81.6575 143.658 83 142 83C140.342 83 139 81.6575 139 80C139 78.3425 140.342 77 142 77C143.658 77 145 78.3425 145 80Z",
    fill: "#20E9BC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 80C160 81.6575 158.658 83 157 83C155.342 83 154 81.6575 154 80C154 78.3425 155.342 77 157 77C158.658 77 160 78.3425 160 80Z",
    fill: "#20E9BC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 80C176 81.6575 174.658 83 173 83C171.342 83 170 81.6575 170 80C170 78.3425 171.342 77 173 77C174.658 77 176 78.3425 176 80Z",
    fill: "#20E9BC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 96C6 97.6575 4.6575 99 3 99C1.3425 99 0 97.6575 0 96C0 94.3425 1.3425 93 3 93C4.6575 93 6 94.3425 6 96Z",
    fill: "#20E9BC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 96C22 97.6575 20.6575 99 19 99C17.3425 99 16 97.6575 16 96C16 94.3425 17.3425 93 19 93C20.6575 93 22 94.3425 22 96Z",
    fill: "#20E9BC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 96C37 97.6575 35.6575 99 34 99C32.3425 99 31 97.6575 31 96C31 94.3425 32.3425 93 34 93C35.6575 93 37 94.3425 37 96Z",
    fill: "#20E9BC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 96C52 97.6575 50.6575 99 49 99C47.3425 99 46 97.6575 46 96C46 94.3425 47.3425 93 49 93C50.6575 93 52 94.3425 52 96Z",
    fill: "#20E9BC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 96C68 97.6575 66.6575 99 65 99C63.3425 99 62 97.6575 62 96C62 94.3425 63.3425 93 65 93C66.6575 93 68 94.3425 68 96Z",
    fill: "#20E9BC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 96C83 97.6575 81.6575 99 80 99C78.3425 99 77 97.6575 77 96C77 94.3425 78.3425 93 80 93C81.6575 93 83 94.3425 83 96Z",
    fill: "#20E9BC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 96C99 97.6575 97.6575 99 96 99C94.3425 99 93 97.6575 93 96C93 94.3425 94.3425 93 96 93C97.6575 93 99 94.3425 99 96Z",
    fill: "#20E9BC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 96C114 97.6575 112.658 99 111 99C109.342 99 108 97.6575 108 96C108 94.3425 109.342 93 111 93C112.658 93 114 94.3425 114 96Z",
    fill: "#20E9BC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 96C130 97.6575 128.658 99 127 99C125.342 99 124 97.6575 124 96C124 94.3425 125.342 93 127 93C128.658 93 130 94.3425 130 96Z",
    fill: "#20E9BC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 96C145 97.6575 143.658 99 142 99C140.342 99 139 97.6575 139 96C139 94.3425 140.342 93 142 93C143.658 93 145 94.3425 145 96Z",
    fill: "#20E9BC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 96C160 97.6575 158.658 99 157 99C155.342 99 154 97.6575 154 96C154 94.3425 155.342 93 157 93C158.658 93 160 94.3425 160 96Z",
    fill: "#20E9BC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 96C176 97.6575 174.658 99 173 99C171.342 99 170 97.6575 170 96C170 94.3425 171.342 93 173 93C174.658 93 176 94.3425 176 96Z",
    fill: "#20E9BC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 111C6 112.658 4.6575 114 3 114C1.3425 114 0 112.658 0 111C0 109.342 1.3425 108 3 108C4.6575 108 6 109.342 6 111Z",
    fill: "#20E9BC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 111C22 112.658 20.6575 114 19 114C17.3425 114 16 112.658 16 111C16 109.342 17.3425 108 19 108C20.6575 108 22 109.342 22 111Z",
    fill: "#20E9BC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 111C37 112.658 35.6575 114 34 114C32.3425 114 31 112.658 31 111C31 109.342 32.3425 108 34 108C35.6575 108 37 109.342 37 111Z",
    fill: "#20E9BC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 111C52 112.658 50.6575 114 49 114C47.3425 114 46 112.658 46 111C46 109.342 47.3425 108 49 108C50.6575 108 52 109.342 52 111Z",
    fill: "#20E9BC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 111C68 112.658 66.6575 114 65 114C63.3425 114 62 112.658 62 111C62 109.342 63.3425 108 65 108C66.6575 108 68 109.342 68 111Z",
    fill: "#20E9BC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 111C83 112.658 81.6575 114 80 114C78.3425 114 77 112.658 77 111C77 109.342 78.3425 108 80 108C81.6575 108 83 109.342 83 111Z",
    fill: "#20E9BC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 111C99 112.658 97.6575 114 96 114C94.3425 114 93 112.658 93 111C93 109.342 94.3425 108 96 108C97.6575 108 99 109.342 99 111Z",
    fill: "#20E9BC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 111C114 112.658 112.658 114 111 114C109.342 114 108 112.658 108 111C108 109.342 109.342 108 111 108C112.658 108 114 109.342 114 111Z",
    fill: "#20E9BC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 111C130 112.658 128.658 114 127 114C125.342 114 124 112.658 124 111C124 109.342 125.342 108 127 108C128.658 108 130 109.342 130 111Z",
    fill: "#20E9BC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 111C145 112.658 143.658 114 142 114C140.342 114 139 112.658 139 111C139 109.342 140.342 108 142 108C143.658 108 145 109.342 145 111Z",
    fill: "#20E9BC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 111C160 112.658 158.658 114 157 114C155.342 114 154 112.658 154 111C154 109.342 155.342 108 157 108C158.658 108 160 109.342 160 111Z",
    fill: "#20E9BC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 111C176 112.658 174.658 114 173 114C171.342 114 170 112.658 170 111C170 109.342 171.342 108 173 108C174.658 108 176 109.342 176 111Z",
    fill: "#20E9BC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 126C6 127.658 4.6575 129 3 129C1.3425 129 0 127.658 0 126C0 124.342 1.3425 123 3 123C4.6575 123 6 124.342 6 126Z",
    fill: "#20E9BC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 126C22 127.658 20.6575 129 19 129C17.3425 129 16 127.658 16 126C16 124.342 17.3425 123 19 123C20.6575 123 22 124.342 22 126Z",
    fill: "#20E9BC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 126C37 127.658 35.6575 129 34 129C32.3425 129 31 127.658 31 126C31 124.342 32.3425 123 34 123C35.6575 123 37 124.342 37 126Z",
    fill: "#20E9BC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 126C52 127.658 50.6575 129 49 129C47.3425 129 46 127.658 46 126C46 124.342 47.3425 123 49 123C50.6575 123 52 124.342 52 126Z",
    fill: "#20E9BC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 126C68 127.658 66.6575 129 65 129C63.3425 129 62 127.658 62 126C62 124.342 63.3425 123 65 123C66.6575 123 68 124.342 68 126Z",
    fill: "#20E9BC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 126C83 127.658 81.6575 129 80 129C78.3425 129 77 127.658 77 126C77 124.342 78.3425 123 80 123C81.6575 123 83 124.342 83 126Z",
    fill: "#20E9BC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 126C99 127.658 97.6575 129 96 129C94.3425 129 93 127.658 93 126C93 124.342 94.3425 123 96 123C97.6575 123 99 124.342 99 126Z",
    fill: "#20E9BC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 126C114 127.658 112.658 129 111 129C109.342 129 108 127.658 108 126C108 124.342 109.342 123 111 123C112.658 123 114 124.342 114 126Z",
    fill: "#20E9BC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 126C130 127.658 128.658 129 127 129C125.342 129 124 127.658 124 126C124 124.342 125.342 123 127 123C128.658 123 130 124.342 130 126Z",
    fill: "#20E9BC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 126C145 127.658 143.658 129 142 129C140.342 129 139 127.658 139 126C139 124.342 140.342 123 142 123C143.658 123 145 124.342 145 126Z",
    fill: "#20E9BC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 126C160 127.658 158.658 129 157 129C155.342 129 154 127.658 154 126C154 124.342 155.342 123 157 123C158.658 123 160 124.342 160 126Z",
    fill: "#20E9BC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 126C176 127.658 174.658 129 173 129C171.342 129 170 127.658 170 126C170 124.342 171.342 123 173 123C174.658 123 176 124.342 176 126Z",
    fill: "#20E9BC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 142C6 143.658 4.6575 145 3 145C1.3425 145 0 143.658 0 142C0 140.342 1.3425 139 3 139C4.6575 139 6 140.342 6 142Z",
    fill: "#20E9BC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 142C22 143.658 20.6575 145 19 145C17.3425 145 16 143.658 16 142C16 140.342 17.3425 139 19 139C20.6575 139 22 140.342 22 142Z",
    fill: "#20E9BC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 142C37 143.658 35.6575 145 34 145C32.3425 145 31 143.658 31 142C31 140.342 32.3425 139 34 139C35.6575 139 37 140.342 37 142Z",
    fill: "#20E9BC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 142C52 143.658 50.6575 145 49 145C47.3425 145 46 143.658 46 142C46 140.342 47.3425 139 49 139C50.6575 139 52 140.342 52 142Z",
    fill: "#20E9BC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 142C68 143.658 66.6575 145 65 145C63.3425 145 62 143.658 62 142C62 140.342 63.3425 139 65 139C66.6575 139 68 140.342 68 142Z",
    fill: "#20E9BC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 142C83 143.658 81.6575 145 80 145C78.3425 145 77 143.658 77 142C77 140.342 78.3425 139 80 139C81.6575 139 83 140.342 83 142Z",
    fill: "#20E9BC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 142C99 143.658 97.6575 145 96 145C94.3425 145 93 143.658 93 142C93 140.342 94.3425 139 96 139C97.6575 139 99 140.342 99 142Z",
    fill: "#20E9BC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 142C114 143.658 112.658 145 111 145C109.342 145 108 143.658 108 142C108 140.342 109.342 139 111 139C112.658 139 114 140.342 114 142Z",
    fill: "#20E9BC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 142C130 143.658 128.658 145 127 145C125.342 145 124 143.658 124 142C124 140.342 125.342 139 127 139C128.658 139 130 140.342 130 142Z",
    fill: "#20E9BC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 142C145 143.658 143.658 145 142 145C140.342 145 139 143.658 139 142C139 140.342 140.342 139 142 139C143.658 139 145 140.342 145 142Z",
    fill: "#20E9BC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 142C160 143.658 158.658 145 157 145C155.342 145 154 143.658 154 142C154 140.342 155.342 139 157 139C158.658 139 160 140.342 160 142Z",
    fill: "#20E9BC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 142C176 143.658 174.658 145 173 145C171.342 145 170 143.658 170 142C170 140.342 171.342 139 173 139C174.658 139 176 140.342 176 142Z",
    fill: "#20E9BC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 157C6 158.658 4.6575 160 3 160C1.3425 160 0 158.658 0 157C0 155.342 1.3425 154 3 154C4.6575 154 6 155.342 6 157Z",
    fill: "#20E9BC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 157C22 158.658 20.6575 160 19 160C17.3425 160 16 158.658 16 157C16 155.342 17.3425 154 19 154C20.6575 154 22 155.342 22 157Z",
    fill: "#20E9BC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 157C37 158.658 35.6575 160 34 160C32.3425 160 31 158.658 31 157C31 155.342 32.3425 154 34 154C35.6575 154 37 155.342 37 157Z",
    fill: "#20E9BC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 157C52 158.658 50.6575 160 49 160C47.3425 160 46 158.658 46 157C46 155.342 47.3425 154 49 154C50.6575 154 52 155.342 52 157Z",
    fill: "#20E9BC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 157C68 158.658 66.6575 160 65 160C63.3425 160 62 158.658 62 157C62 155.342 63.3425 154 65 154C66.6575 154 68 155.342 68 157Z",
    fill: "#20E9BC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 157C83 158.658 81.6575 160 80 160C78.3425 160 77 158.658 77 157C77 155.342 78.3425 154 80 154C81.6575 154 83 155.342 83 157Z",
    fill: "#20E9BC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 157C99 158.658 97.6575 160 96 160C94.3425 160 93 158.658 93 157C93 155.342 94.3425 154 96 154C97.6575 154 99 155.342 99 157Z",
    fill: "#20E9BC"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 157C114 158.658 112.658 160 111 160C109.342 160 108 158.658 108 157C108 155.342 109.342 154 111 154C112.658 154 114 155.342 114 157Z",
    fill: "#20E9BC"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 157C130 158.658 128.658 160 127 160C125.342 160 124 158.658 124 157C124 155.342 125.342 154 127 154C128.658 154 130 155.342 130 157Z",
    fill: "#20E9BC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 157C145 158.658 143.658 160 142 160C140.342 160 139 158.658 139 157C139 155.342 140.342 154 142 154C143.658 154 145 155.342 145 157Z",
    fill: "#20E9BC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 157C160 158.658 158.658 160 157 160C155.342 160 154 158.658 154 157C154 155.342 155.342 154 157 154C158.658 154 160 155.342 160 157Z",
    fill: "#20E9BC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 157C176 158.658 174.658 160 173 160C171.342 160 170 158.658 170 157C170 155.342 171.342 154 173 154C174.658 154 176 155.342 176 157Z",
    fill: "#20E9BC"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 173C6 174.658 4.6575 176 3 176C1.3425 176 0 174.658 0 173C0 171.342 1.3425 170 3 170C4.6575 170 6 171.342 6 173Z",
    fill: "#20E9BC"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 173C22 174.658 20.6575 176 19 176C17.3425 176 16 174.658 16 173C16 171.342 17.3425 170 19 170C20.6575 170 22 171.342 22 173Z",
    fill: "#20E9BC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 173C37 174.658 35.6575 176 34 176C32.3425 176 31 174.658 31 173C31 171.342 32.3425 170 34 170C35.6575 170 37 171.342 37 173Z",
    fill: "#20E9BC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 173C52 174.658 50.6575 176 49 176C47.3425 176 46 174.658 46 173C46 171.342 47.3425 170 49 170C50.6575 170 52 171.342 52 173Z",
    fill: "#20E9BC"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 173C68 174.658 66.6575 176 65 176C63.3425 176 62 174.658 62 173C62 171.342 63.3425 170 65 170C66.6575 170 68 171.342 68 173Z",
    fill: "#20E9BC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 173C83 174.658 81.6575 176 80 176C78.3425 176 77 174.658 77 173C77 171.342 78.3425 170 80 170C81.6575 170 83 171.342 83 173Z",
    fill: "#20E9BC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 173C99 174.658 97.6575 176 96 176C94.3425 176 93 174.658 93 173C93 171.342 94.3425 170 96 170C97.6575 170 99 171.342 99 173Z",
    fill: "#20E9BC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 173C114 174.658 112.658 176 111 176C109.342 176 108 174.658 108 173C108 171.342 109.342 170 111 170C112.658 170 114 171.342 114 173Z",
    fill: "#20E9BC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 173C130 174.658 128.658 176 127 176C125.342 176 124 174.658 124 173C124 171.342 125.342 170 127 170C128.658 170 130 171.342 130 173Z",
    fill: "#20E9BC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 173C145 174.658 143.658 176 142 176C140.342 176 139 174.658 139 173C139 171.342 140.342 170 142 170C143.658 170 145 171.342 145 173Z",
    fill: "#20E9BC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 173C160 174.658 158.658 176 157 176C155.342 176 154 174.658 154 173C154 171.342 155.342 170 157 170C158.658 170 160 171.342 160 173Z",
    fill: "#20E9BC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 173C176 174.658 174.658 176 173 176C171.342 176 170 174.658 170 173C170 171.342 171.342 170 173 170C174.658 170 176 171.342 176 173Z",
    fill: "#20E9BC"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 188C6 189.658 4.6575 191 3 191C1.3425 191 0 189.658 0 188C0 186.342 1.3425 185 3 185C4.6575 185 6 186.342 6 188Z",
    fill: "#20E9BC"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 188C22 189.658 20.6575 191 19 191C17.3425 191 16 189.658 16 188C16 186.342 17.3425 185 19 185C20.6575 185 22 186.342 22 188Z",
    fill: "#20E9BC"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 188C37 189.658 35.6575 191 34 191C32.3425 191 31 189.658 31 188C31 186.342 32.3425 185 34 185C35.6575 185 37 186.342 37 188Z",
    fill: "#20E9BC"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 188C52 189.658 50.6575 191 49 191C47.3425 191 46 189.658 46 188C46 186.342 47.3425 185 49 185C50.6575 185 52 186.342 52 188Z",
    fill: "#20E9BC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 188C68 189.658 66.6575 191 65 191C63.3425 191 62 189.658 62 188C62 186.342 63.3425 185 65 185C66.6575 185 68 186.342 68 188Z",
    fill: "#20E9BC"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 188C83 189.658 81.6575 191 80 191C78.3425 191 77 189.658 77 188C77 186.342 78.3425 185 80 185C81.6575 185 83 186.342 83 188Z",
    fill: "#20E9BC"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 188C99 189.658 97.6575 191 96 191C94.3425 191 93 189.658 93 188C93 186.342 94.3425 185 96 185C97.6575 185 99 186.342 99 188Z",
    fill: "#20E9BC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 188C114 189.658 112.658 191 111 191C109.342 191 108 189.658 108 188C108 186.342 109.342 185 111 185C112.658 185 114 186.342 114 188Z",
    fill: "#20E9BC"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 188C130 189.658 128.658 191 127 191C125.342 191 124 189.658 124 188C124 186.342 125.342 185 127 185C128.658 185 130 186.342 130 188Z",
    fill: "#20E9BC"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 188C145 189.658 143.658 191 142 191C140.342 191 139 189.658 139 188C139 186.342 140.342 185 142 185C143.658 185 145 186.342 145 188Z",
    fill: "#20E9BC"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 188C160 189.658 158.658 191 157 191C155.342 191 154 189.658 154 188C154 186.342 155.342 185 157 185C158.658 185 160 186.342 160 188Z",
    fill: "#20E9BC"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 188C176 189.658 174.658 191 173 191C171.342 191 170 189.658 170 188C170 186.342 171.342 185 173 185C174.658 185 176 186.342 176 188Z",
    fill: "#20E9BC"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3C22 4.6575 20.6575 6 19 6C17.3425 6 16 4.6575 16 3C16 1.3425 17.3425 0 19 0C20.6575 0 22 1.3425 22 3Z",
    fill: "#20E9BC"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 3C37 4.6575 35.6575 6 34 6C32.3425 6 31 4.6575 31 3C31 1.3425 32.3425 0 34 0C35.6575 0 37 1.3425 37 3Z",
    fill: "#20E9BC"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 3C52 4.6575 50.6575 6 49 6C47.3425 6 46 4.6575 46 3C46 1.3425 47.3425 0 49 0C50.6575 0 52 1.3425 52 3Z",
    fill: "#20E9BC"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 3C68 4.6575 66.6575 6 65 6C63.3425 6 62 4.6575 62 3C62 1.3425 63.3425 0 65 0C66.6575 0 68 1.3425 68 3Z",
    fill: "#20E9BC"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 3C83 4.6575 81.6575 6 80 6C78.3425 6 77 4.6575 77 3C77 1.3425 78.3425 0 80 0C81.6575 0 83 1.3425 83 3Z",
    fill: "#20E9BC"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 3C99 4.6575 97.6575 6 96 6C94.3425 6 93 4.6575 93 3C93 1.3425 94.3425 0 96 0C97.6575 0 99 1.3425 99 3Z",
    fill: "#20E9BC"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 3C114 4.6575 112.658 6 111 6C109.342 6 108 4.6575 108 3C108 1.3425 109.342 0 111 0C112.658 0 114 1.3425 114 3Z",
    fill: "#20E9BC"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 3C130 4.6575 128.658 6 127 6C125.342 6 124 4.6575 124 3C124 1.3425 125.342 0 127 0C128.658 0 130 1.3425 130 3Z",
    fill: "#20E9BC"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145 3C145 4.6575 143.658 6 142 6C140.342 6 139 4.6575 139 3C139 1.3425 140.342 0 142 0C143.658 0 145 1.3425 145 3Z",
    fill: "#20E9BC"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 3C160 4.6575 158.658 6 157 6C155.342 6 154 4.6575 154 3C154 1.3425 155.342 0 157 0C158.658 0 160 1.3425 160 3Z",
    fill: "#20E9BC"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 3C176 4.6575 174.658 6 173 6C171.342 6 170 4.6575 170 3C170 1.3425 171.342 0 173 0C174.658 0 176 1.3425 176 3Z",
    fill: "#20E9BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowDotPattern);
export default __webpack_public_path__ + "static/media/Grow_Dot_Pattern.6cb2ce8565268df30923564ebe16ac34.svg";
export { ForwardRef as ReactComponent };